<template>
  <el-dialog custom-class="transformer-package-container dialog-size-large"
             :title="transformerPackage.packageName"
             :visible.sync="visible"
             :append-to-body="true"
             top="0"
             :modal="false"
             :before-close="beforeClose"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="transform-section-main">
      <div class="transformer-item-container" v-for="(transformer, index) in transformers">
        <div class="transformer-item-container-separator">
          <font-awesome-icon class="icon arrow" icon="arrow-right" v-if="index > 0"/>
        </div>
        <transformer-item :transformer="transformer.transformer"
                          :summary="transformer.summary"
                          :deletable="isDeletableTransformer(transformer.summary.transformerId)"
                          @setting="onSettingTransformer(transformer.summary, index)"
                          @selected="onSelectTransformer(index)"
                          @deselected="onDeselectTransformer(index)">
        </transformer-item>
      </div>

      <transformer-setting v-if="settingTransformer != null && visibleTransformerSetting"
                           :visible="visibleTransformerSetting"
                           :transformer="settingTransformer.transformer"
                           :transformerSummary="settingTransformer.summary"
                           @close="settingTransformer=null;visibleTransformerSetting=false"
                           @setting="onUpdateTransformer(transformer)">
      </transformer-setting>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="beforeClose">キャンセル</el-button>
      <el-button type="primary" @click="onSelectTransformers">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TransformerItemCmp from '../../train/transform/item.vue'
import TransformerSettingCmp from '../../train/dialogs/transformer-setting.vue'
import { Transformer, TransformerPackage, TransformerSummary } from '../../../../defines/transformer'
import CommonUtil from '../../../../utils/common'
import MessageBox from '../../../../utils/message-box'

export default {
  name: 'TransformerPackageDetailCmp',
  components: {
    'transformer-item': TransformerItemCmp,
    'transformer-setting': TransformerSettingCmp
  },
  props: {
    transformerPackage: TransformerPackage,
    transformers: {
      transformer: Transformer,
      summary: TransformerSummary
    }
  },
  data () {
    return {
      tempTransformers: [],

      visible: true,
      updateFlagclass: false,

      settingTransformer: {
        transformer: Transformer,
        summary: TransformerSummary
      },

      visibleTransformerSetting: false
    }
  },
  mounted () {
    this.transformers.forEach((srcTransformer) => {
      let tempTransformer = {
        transformerId: srcTransformer.summary.transformerId,
        use: srcTransformer.transformer.use
      }
      const tempHyperParams = srcTransformer.transformer.hyperParams
      if (CommonUtil.isNotEmpty(tempHyperParams)) {
        tempTransformer.hyperParams = tempHyperParams
      }
      this.tempTransformers.push(tempTransformer)
    })
  },
  methods: {
    onSettingTransformer (transformerSummary, index) {
      let tempTransformer = this.tempTransformers[index]
      let tempTransformerSummary = Object.assign({}, transformerSummary)
      tempTransformerSummary.hyperParams = []

      if (CommonUtil.isNotEmpty(transformerSummary.hyperParams)) {
        let tempHyperParams = []
        if (CommonUtil.isNull(tempTransformer.hyperParams)) {
          tempTransformer.hyperParams = []
        }
        const existHyperParamIds = tempTransformer.hyperParams.map(value => value.hyperParamId)
        for (let hyperParamSummary of transformerSummary.hyperParams) {
          const hyperParamId = hyperParamSummary.hyperParamId

          const NonUseHyperParams = ['to_be_dummy', 'return_input']
          if (!NonUseHyperParams.find(NonUseHyperParamId => NonUseHyperParamId === hyperParamId)) {
            let hyperParamValue
            if (existHyperParamIds.indexOf(hyperParamId) >= 0) {
              // if exist.
              hyperParamValue = tempTransformer.hyperParams.filter(
                value => value.hyperParamId === hyperParamId)[0].value
            } else {
              // if not exist.
              hyperParamValue = hyperParamSummary.defaultVal

              // set default values from transformer package default option.
              if (CommonUtil.isNotEmpty(this.transformerPackage.defaultOptions)) {
                const packageDefaultValues = this.transformerPackage.defaultOptions.find(
                  option => option.transformerId === tempTransformer.transformerId)
                const packageHyperParams = CommonUtil.isNotEmpty(packageDefaultValues)
                  ? packageDefaultValues.defaultHyperParams
                  : []

                const defaultParam = packageHyperParams.find(
                  packageHyperParam => packageHyperParam.hyperParamId === hyperParamId)
                if (defaultParam) {
                  hyperParamValue = defaultParam.defaultVal
                }
              }
            }

            tempTransformerSummary.hyperParams.push(hyperParamSummary)
            tempHyperParams.push({
              hyperParamId: hyperParamId,
              value: hyperParamValue
            })
          }
        }
        tempTransformer.hyperParams = tempHyperParams
      }

      this.settingTransformer = {
        transformer: tempTransformer,
        summary: tempTransformerSummary
      }

      this.visibleTransformerSetting = true
    },
    isDeletableTransformer (transformerId) {
      const targetTransformer = this.transformers.find(
        transformer => transformer.summary.transformerId === transformerId)
      if (CommonUtil.isNotEmpty(targetTransformer.summary.rules)) {
        for (const rule of targetTransformer.summary.rules) {
          if (rule.required === true) {
            return true
          }
        }
      }
    },
    onUpdateTransformer (transformer) {
      this.updateFlag = true
    },
    onSelectTransformer (index) {
      this.tempTransformers[index].use = true
    },
    onDeselectTransformer (index) {
      this.tempTransformers[index].use = false
    },
    isChangeUsingTransformer () {
      for (let i = 0; i < this.tempTransformers.length; i++) {
        if (this.tempTransformers[i].use !== this.transformers[i].transformer.use) {
          return true
        }
      }
      return false
    },
    beforeClose () {
      if (this.updateFlag === true || this.isChangeUsingTransformer()) {
        MessageBox.confirm(this, `変更を破棄して元の画面に戻りますか？`, {
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.visible = false
        }).catch(() => {})
      } else {
        this.visible = false
      }
    },
    onSelectTransformers () {
      this.$emit('update', this.tempTransformers)
      this.visible = false
    }
  }
}

</script>

<style scoped>
  .transformer-package-container {
    padding: 24px;
  }

  .transform-section-main {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: start;
    border: solid 1px #c0d5ef;
    border-radius: 2px;
    padding: 12px 24px 12px 6px;
    margin: 0;
    min-height: 148px;
  }

  .transformer-item-container {
    display: flex;
    align-items: center;
    margin: 8px 5px;
    height: 100px;
    position: relative;
  }

  .transformer-item-container-separator {
    width: 14px;
    margin-right: 10px;
  }

  .transformer-item-container-separator {
    display: flex;
    flex-direction: column;
  }

  .transformer-item-container-separator .icon.arrow {
    margin-left: 1px;
    color: #888;
  }

  .transformer-item-container-separator .icon.insert {
    margin-top: 10px;
    cursor: pointer;
    color: #2456d4;
  }

  .transformer-item-container-separator .icon.insert:hover {
    opacity: 0.7;
  }

</style>



// WEBPACK FOOTER //
// src/components/model/train/dialogs/transformer-package-detail.vue